{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "taxpayers": {
    "name": "Taxpayer name"
  },
  "dashboard": {
    "statistics": "Statistics",
    "jurisdictions": "Jurisdictions",
    "pendingDisbursements": "Pending disbursements",
    "payments": "Payments",
    "taxpayers": "Taxpayers",
    "firstPayment": "First payment",
    "lastPayment": "Last payment",
    "actualSituation": "Current situation",
    "totalAmount": "Total amount",
    "currentAccount": "Current account",
    "taxReturns": "$t(config.taxReturns)",
    "taxReturnsRecent": "Recent documents"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number",
    "taxReturn": "POSS return",
    "taxReturns": "POSS returns"
  },
  "currentAccounts": {
    "transactionType": "Transaction type",
    "credit": "Credit",
    "debit": "Debit",
    "document": "Document"
  },
  "menu": {
    "label": {
      "security": "Security",
      "users": "Users",
      "apikey": "Api Key",
      "twoFactorAuthentication": "Two Factor Authentication",
      "configuration": "Configuration",
      "notifications-application": "Notifications Application",
      "notifications-security": "Notifications Security",
      "environment-application": "Environment Application",
      "environment-security": "Environment Security",
      "operations": "Operations",
      "economy-activity": "Operation",
      "catalog": "Catalog type",
      "taxpayer-fields": "Taxpayer fields",
      "taxes": "Taxes",
      "manage-tax": "Manage Taxes"
    }
  },
  "collections": {
    "label": {
      "maximumNumberOfTaxpayers": "Maximum number of taxpayers",
      "durationProcess": "Duration days",
      "descriptionProcess": "Description",
      "selectedTaxpayers": "Selected",
      "excludedTaxpayers": "Excluded",
      "debtDetail": "See debt detail",
      "lastTaxreturn": "Last $t(config.taxReturn)",
      "lastPayment": "Last payment",
      "excluded": "Excluded",
      "debtOriginal": "Original debt",
      "debtFinal": "Final debt",
      "currentDebt": "Current debt",
      "code": "Identifier",
      "taxpayer": "Taxpayer",
      "start": "Start",
      "end": "End",
      "newCommunication": "New communication",
      "typeCommunication": "Communication channel",
      "saveCommunication": "Save communication",
      "communicationChannelPhone": "Phone",
      "communicationChannelMail": "Mail",
      "process": "Process",
      "startProcess": "Started process",
      "recoveredDebt": "Debt recovered",
      "endProcess": "End process",
      "timeElapsed": "Average response",
      "countProcess": "Processes",
      "countEndedProcess": "Finished",
      "countInProgressProcess": "In process",
      "countTaxpayerProcess": "Taxpayers",
      "unpaid": "Unpaid",
      "noCommunications": "No communications"
    },
    "title": {
      "detailCollection": "Payment information",
      "newProcessCollection": "New collection process",
      "selectionTaxpayerProcess": "Selection of taxpayers",
      "indicators": "Indicators",
      "taxreturnAndPayments": "$t(config.taxReturn)s and payments",
      "communications": "Communications",
      "processCollection": "Collection processes",
      "StatisticQuery": "Consultarion period",
      "StatisticQueryResult": "Results"
    },
    "status": {
      "started": "Started",
      "ended": "Ended"
    },
    "messages": {
      "newProcessCreated": "A new collection process was created with [limit] taxpayers which began on [startDate] and ends on [endDate]"
    }
  },
  "administration-user": {
    "title": {
      "page": "Users",
      "page-taxpayer": "Taxpayers",
      "page-disable-tfa": "Disable Two Factor Authentication (2FA)",
      "activation-link-confirmation": "Confirm activation link"
    },
    "label": {
      "userName": "User Name",
      "department": "Department",
      "roles": "Roles",
      "general-information": "General information",
      "user": "New user",
      "edit-user": "Edit user",
      "disabled": "Disabled",
      "email-confirmed": "Email confirmed",
      "invitation-sent-at": "Invitation sent at",
      "invitation-not-sent": "Not sent",
      "locale": "Preferred Language",
      "disable": "Disable",
      "enable": "Enable",
      "cancel": "Cancel",
      "return": "Return"
    },
    "button": {
      "send-activation-link": "Send activation link",
      "resend-activation-link": "Resend activation link"
    },
    "validations": {
      "userName": "User Name is required"
    },
    "messages": {
      "disableTitle": "Disable user",
      "confirmDisable": "Are you sure you want to disable this user?",
      "confirmEnable": "Are you sure you want to Enable this user?",
      "savedSucessfully": "Saved successfully",
      "enableTitle": "Enable user",
      "error": "Error",
      "confirmDisableTfaTitle": "Disable 2FA",
      "confirmDisableTfa": "Are you sure sure do you want to disable Two Factor Authentication to user \"{0}\"?",
      "tfaDisabledSucessfully": "Two Factor Authentication disabled successfully",
      "activation-link-sent": "Activation link sent",
      "confirm-send-activation-link": "Are you sure you want to send an activation link to this user?",
      "confirm-resend-activation-link": "Are you sure you want to resend the activation link to this user?"
    }
  },
  "user-profile": {
    "title": {
      "page": "User Profile",
      "change-password": "Change Password"
    },
    "label": {
      "userName": "User Name",
      "name": "Full Name",
      "email": "Email",
      "locale": "Preferred Language",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "repeatPassword": "Repeat password",
      "change-password": "Change Password",
      "password": "Password"
    },
    "message": {
      "password-changed": "Password changed successfully",
      "profile-updated": "Profile updated successfully. Must logout to see the changes",
      "password": "Update your account password to keep your account secure"
    }
  },
  "common": {
    "label": {
      "period": "Period",
      "jurisdiction": "Jurisdiction",
      "valueType": "Value type",
      "theme": "Theme",
      "feedback": "Feedback",
      "logout": "Logout",
      "print": "Print",
      "phoneNumberArea": "Prefix / Area Code",
      "newRecord": "New",
      "editRecord": "Update",
      "current-user": "Current user",
      "user-profile": "User profile",
      "name": "Name",
      "givenNames": "Given names",
      "surnames": "Surname",
      "search": "Search",
      "clean": "Clean",
      "create": "Create",
      "ok": "Ok",
      "next": "Next",
      "cancel": "Cancel",
      "back": "Back",
      "edit": "Edit",
      "actions": "Actions",
      "selectAction": "Select action",
      "send": "Send",
      "close": "Close",
      "add": "Add",
      "email": "Email",
      "phoneNumber": "Phone Number",
      "id": "Id",
      "password": "Password",
      "state": "Disabled",
      "translation": "Translation",
      "language": "Language",
      "value": "Value",
      "translatable": "Translatable",
      "politicalDivision": "Political division",
      "department": "Department/Provice/State",
      "city": "City",
      "zipCode": "Zip Code",
      "cellPhone": "Cell phone",
      "personType": "Person type",
      "businessName": "Business name",
      "taxpayerName": "Full name or Business name",
      "tradeName": "Trading name",
      "address": "Business address",
      "country": "Country",
      "localization": "Localization",
      "website": "Website/s",
      "fileSearch": "Search file",
      "fileUpload": "Upload file",
      "fileDownload": "Download file",
      "noFileSelected": "No file selected",
      "fileRequirements": "PDF · Max. 9.6 MB",
      "fileUploading": "Uploading...",
      "fileUploaded": "Uploaded",
      "fileUploadError": "The file could not be uploaded",
      "fileSelect": "Select",
      "fileReplace": "Replace",
      "fileRemove": "Remove",
      "fileRemoving": "Removing...",
      "fileRemoveError": "The file could not be removed",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "noFound": "There is no result",
      "taxReturnCurrency": "Taxreturn Currency",
      "page-showing": "Showing",
      "page-to": "to",
      "page-of": "of",
      "page-entries": "entries",
      "loading": "Loading...",
      "error": "Error",
      "unableToLoad": "Unable to load data. Please try again.",
      "retry": "Retry",
      "currency": "Currency",
      "paymentMethod": "Payment method",
      "attachment": "Attachment",
      "paymentReference": "Additional information",
      "supportDocument": "Support document",
      "payment": "Payment",
      "backToHome": "Back to Home",
      "createdBy": "Created by",
      "bank": "Bank",
      "bankInformation": "Bank Information",
      "excel": "Excel",
      "days": {
        "monday": "Mo",
        "tuesday": "Tu",
        "wednesday": "We",
        "thursday": "Th",
        "friday": "Fr",
        "saturday": "Sa",
        "sunday": "Su"
      },
      "months": {
        "january": "January",
        "february": "February",
        "march": "March",
        "april": "April",
        "may": "May",
        "june": "June",
        "july": "July",
        "august": "August",
        "september": "September",
        "october": "October",
        "november": "November",
        "december": "December"
      },
      "type": "Type",
      "numeric": "Numeric",
      "date": "Date",
      "list": "List",
      "text": "Text",
      "header": "Header",
      "description": "Description",
      "ommited": "Omitted",
      "all": "All",
      "see": "Show",
      "filters": "Filters"
    },
    "descriptions": {
      "taxReturnCurrency": "Currency used for Taxreturns",
      "can-access": "Can access",
      "contactTaxIdNumber-tax": "Tax Identification Number of the contact in the country of residence"
    },
    "button": {
      "close": "Close",
      "add": "Add",
      "edit": "Edit",
      "find": "Search",
      "cancel": "Cancel",
      "delete": "Delete",
      "save": "Save",
      "clean": "Clear",
      "new": "New",
      "show": "Show",
      "download": "Download",
      "file": "Attachment",
      "previous": "Previous",
      "next": "Next",
      "send": "Send",
      "translate": "Add translation",
      "return": "Return",
      "continue": "Continue",
      "newVersion": "New version"
    },
    "dialog": {
      "dialog-error": "Errors",
      "table-title-header": "Messages",
      "warning-title": "Attention"
    },
    "messages": {
      "error-500": "An error occurred on the server, please contact the administrator.",
      "fileUpload": "The file was uploaded successfully",
      "savedSucessfully": "Saved successfully",
      "deletedSucessfully": "Deleted successfully",
      "pleaseWait": "Please wait",
      "nofileContent": "No file content",
      "errorMessageSystem": "Parameter '${code}' was not found in the catalog",
      "warningInactiveSession": "Attention: No activity has been detected in a while. The session will be closed in 1 minute if no activity is detected yet",
      "sessionIdleCountdown": "Your session will close in {{count}} seconds.",
      "closingSession": "Closing Session ...",
      "confirm": "Are you sure you want to perform this action?",
      "uploadProcessing": "The information has been uploaded and is being processed, you will be notified once it has finished processing.",
      "messageSent": "Message sent successfully"
    },
    "validations": {
      "nameRequired": "The field Name is required",
      "fieldRequired": "Field is required",
      "numbersAndLetters": "Only numbers and letters",
      "email": "Invalid email",
      "minStringValue": "Field must be at least {{min}} characters",
      "maxStringValue": "Field must be at most {{max}} characters",
      "minNumberValue": "Field value must be at least {{min}}",
      "maxNumberValue": "Field value must be at most {{max}}"
    },
    "languages": {
      "spanish": "Spanish (Spain)",
      "english": "English (United States)"
    },
    "taxpayer-request-types": {
      "enroll": "Enroll",
      "update": "Update",
      "unsubscribe": "Unsubscribe"
    },
    "taxpayer-request-states": {
      "pending": "Pending",
      "pending_additional_information": "Pending Additional Information",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Amending"
    },
    "taxreturn-status": {
      "pending": "Pending",
      "accepted": "Accepted",
      "approved": "Approved",
      "rejected": "Rejected",
      "reconciled": "Reconciled"
    },
    "yes-no": {
      "yes": "Yes",
      "no": "No"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconecting",
      "reconected": "Reconected"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Messages"
    },
    "label": {
      "message": "Message",
      "messages": "Messages",
      "read": "Read",
      "inboxDate": "Date",
      "ok": "Ok",
      "no": "NO"
    }
  },
  "management-report": {
    "label": {
      "taxpayerByCountry": "By country",
      "taxpayerByOperation": "By operation",
      "taxpayerAmount": "Amount",
      "taxAmount": "By tax",
      "dateFrom": "Date From",
      "dateTo": "Date To"
    },
    "title": {
      "pageTaxpayer": "Taxpayer",
      "pageTaxreturn": "$t(config.taxReturn)",
      "pagePayment": "Payments"
    },
    "validations": {
      "dateRequired": "This date is required",
      "dateToGreaterThan": "This date should be greater than Date From",
      "dateLessThreeMonths": "This date should be less than 12 months of Date From"
    }
  },
  "non-compliances": {
    "label": {
      "period": "Period",
      "expirationDate": "Expiration date",
      "NotificationDate": "Notification date",
      "presentationDate": "Presentation date",
      "wait": "Wait",
      "penalty": "Penalty",
      "declarationAmount": "Declaration amount",
      "paymentAmount": "Payment amount",
      "days": "days",
      "countTaxpayerNotified": "Notifications",
      "countTaxpayerCompliance": "Compliments",
      "compliancePercentage": "Compliance",
      "elapsedTime": "Average time",
      "debtGenerated": "Generated debt"
    },
    "title": {
      "nonCompliancesTax": "Non-compliance due to tax",
      "nonCompliances": "Non compliances",
      "nonCompliancesPayments": "Pending payments",
      "StatisticQuery": "Consultarion period",
      "StatisticQueryResult": "Results"
    }
  },
  "operations-economy-activity": {
    "title": {
      "page": "Operations"
    },
    "label": {
      "code": "Code",
      "name": "Name",
      "description": "Description",
      "newButton": "New",
      "saveButton": "Save"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "description": "Description",
      "actions": "Actions"
    },
    "button": {
      "cancel": "Cancel",
      "delete": "Delete",
      "save": "Save",
      "search": "Search",
      "new": "New",
      "clean": "Clean",
      "ok": "Ok"
    },
    "validations": {
      "codeRequired": "The code is required",
      "nameRequired": "The field Name is required",
      "descriptionRequired": "The field description is required"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure you want to delete this information?",
      "deletedSucessfully": "Deleted successfully",
      "savedSucessfully": "Saved successfully",
      "error": "Error"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Catalogs",
      "catalog": "Catalog "
    },
    "label": {
      "type": "Type",
      "name": "Name",
      "description": "Description",
      "field": "Field",
      "label": "label",
      "parent": "Parent",
      "newCatalogType": "New catalog type",
      "newCatalog": "New catalog",
      "code": "Code",
      "addDefinition": "Add definition",
      "newDefinition": "New definition",
      "extaFilds": "Additional user fields",
      "addNameTraslation": "Add translation"
    },
    "validations": {
      "exists": "The record already exists",
      "letterNumberhyphen": "Letters number and hyphens are permitted"
    },
    "messages": {
      "languageExist": "Language has already been added"
    }
  },
  "parameters-enviroments": {
    "title": {
      "page-security": "Security Environment",
      "page-application": "Application Environment"
    },
    "label": {
      "name": "Name",
      "type": "Type",
      "value": "Value",
      "newButton": "New",
      "saveButton": "Save"
    },
    "validations": {
      "nameRequired": "The field Name is required",
      "typeRequired": "The field Type is required",
      "textValueRequired": "The field Value is required"
    },
    "messages": {
      "savedSucessfully": "Saved successfully",
      "error": "Error"
    }
  },
  "home-template": {
    "title": {
      "page-home": "Home template",
      "page-terms": "Terms and conditions template"
    },
    "label": {
      "template": "Template"
    },
    "messages": {
      "savedSucessfully": "Saved successfully"
    }
  },
  "parameters-notification-template": {
    "title": {
      "page-application": "Application Notifications",
      "page-security": "Security Notifications"
    },
    "label": {
      "template": "Template",
      "emailNotification": "Email notification",
      "pushNotification": "Push Notification",
      "newTemplate": "New template",
      "id": "Template id",
      "subject": "Subject",
      "inbox": "Folder",
      "header": "Header",
      "footer": "Footer"
    },
    "validations": {
      "templateRequired": "The field Template is required"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Taxpayer Fields",
      "enabled": "Enabled"
    },
    "header": {
      "fieldCode": "Code",
      "fieldName": "Field Name",
      "fieldSection": "Section Name",
      "actions": "Enabled"
    },
    "messages": {
      "savedSucessfully": "Saved successfully"
    }
  },
  "penalties": {
    "label": {
      "periodFrom": "Period from",
      "periodTo": "Period to"
    },
    "title": {
      "listPenalties": "Penalties configuration"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Processing",
      "error": "Error",
      "accepted": "Accepted",
      "processed": "Processed"
    },
    "title": {
      "page": "Report details"
    },
    "label": {
      "reportNumber": "Report number",
      "reportType": "Report type",
      "operations": "Operation type",
      "taxpayerNumber": "Tax payer number",
      "taxpayerName": "Tax payer Name",
      "registrationDate": "Registration Date",
      "period": "Period",
      "reportName": "Report Name",
      "record": "Record",
      "index": "Index",
      "type": "Type",
      "active": "Active",
      "taxReportStatus": "Status"
    }
  },
  "payment-file-status": {
    "processing": "Processing",
    "error": "Error",
    "pending": "Pending",
    "accepted": "Accepted",
    "rejected": "Rejected",
    "processed": "Processed",
    "received": "Received"
  },
  "taxreturn-report": {
    "title": {
      "page": "View $t(config.taxReturns)"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "$t(config.taxReturn) Number",
      "country": "Country",
      "formId": "Form Name",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "name": "Taxpayer Name",
      "period": "Period",
      "periodFrom": "Period From",
      "periodTo": "Period To",
      "active": "Active",
      "overview": "Overview",
      "taxreturn": "$t(config.taxReturn)",
      "createDate": "Create Date",
      "approve": "Approved",
      "comments": "Comments"
    },
    "header": {
      "actions": "Actions",
      "nit": "TIN",
      "name": "Taxpayer Name",
      "taxReturnNumber": "$t(config.taxReturn) Number",
      "createDate": "Create Date",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "form": "Form",
      "period": "Period",
      "active": "Active",
      "rejectionReason": "Reason for Rejection"
    },
    "validations": {},
    "messages": {
      "periodMessage": "For annual periods YYYY format, monthly/quarterly period YYYYMM"
    },
    "button": {}
  },
  "taxreturn-evaluation": {
    "title": {
      "page": "Amendments Revision",
      "approve": "Approve Amendment",
      "reject": "Reject Amendment",
      "dialog-confirm": "Confirm"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "$t(config.taxReturn) Number",
      "country": "Country",
      "taxId": "Tax",
      "taxreturnType": "Operation Type",
      "name": "Taxpayer Name",
      "form": "Form",
      "approve": "Approve",
      "taxpayer": "Taxpayer",
      "comments": "Comments",
      "general-comments": "General Comments",
      "periodFrom": "Period From",
      "periodTo": "Period To"
    },
    "header": {
      "actions": "Actions",
      "nit": "TIN",
      "name": "Taxpayer Name",
      "taxReturnNumber": "$t(config.taxReturn) Number",
      "form": "Form",
      "tax": "Tax",
      "taxreturnStatus": "Status",
      "period": "Period",
      "createDate": "Create Date"
    },
    "validations": {},
    "messages": {
      "approved": "$t(config.taxReturn) Approved",
      "rejected": "$t(config.taxReturn) Rejected",
      "confirm": "Are you sure you want to perform this action?"
    },
    "button": {
      "reject": "Reject",
      "approve": "Approve"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Api Keys"
    },
    "label": {
      "name": "Name",
      "new-api-key": "New Key",
      "expiration": "Expiration Date",
      "your-pat": "Your New Personal Access Token",
      "revoke-token": "Revoke Token"
    },
    "validations": {
      "name": "Api Key Name is required",
      "expiration": "Expiration Date is required"
    },
    "message": {
      "key-created": "Make sure you save it - you won't be able to access it again.",
      "confirm-revoke": "Are you sure do you want to revoke the token?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Event Logs",
      "http-title": "Http Logs",
      "application": "Application",
      "security": "Security"
    },
    "label": {
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "user": "User",
      "aggregateName": "Aggregate Name",
      "eventName": "Event Name",
      "httpMethod": "Http Method",
      "httpStatusCode": "Http Status Code"
    },
    "header": {},
    "validations": {
      "dateRequired": "This date is required",
      "dateToGreaterThan": "This date should be greater than Date From",
      "dateLessThreeMonths": "This date should be less than 3 months of Date From"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Disable two-factor authentication (2FA)",
      "disable": "Disable 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "This action only disables 2FA.",
      "alert-2": "Disabling 2FA does not change the keys used in authenticator apps. ",
      "alert-3": "If you wish to change the key used in an authenticator app you should:",
      "alert-4": "reset your authenticator keys.",
      "success": "2fa has been disabled. You can reenable 2fa when you setup an authenticator app"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configure authenticator app",
      "verification-code": "Verification Code",
      "verification-code-digit": "Digit {{position}} of {{total}}",
      "verify": "Verify",
      "manual-key": "Manual setup key",
      "copy-key": "Copy key",
      "key-copied": "Key copied to clipboard.",
      "key-copied-button": "Copied",
      "copy-unavailable": "The key could not be copied. Copy it manually.",
      "security-recommendations": "Security recommendations",
      "security-recommendations-detail": "Keep recovery codes in a safe place and do not share the setup key."
    },
    "validations": {
      "code": "Verification Code is required"
    },
    "message": {
      "instruction-1": "Download a two-factor authenticator app like Microsoft Authenticator for",
      "and": "and",
      "or": "or",
      "for": "for",
      "instruction-2": "Scan the QR Code or enter this key",
      "instruction-3": "into your two factor authenticator app. Spaces and casing do not matter.",
      "instruction-4": " Once you have scanned the QR code or input the key above, your two factor authentication app will provide you with a unique code. Enter the code in the confirmation box below."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Recovery codes",
      "available-once": "Save them now: they will not be shown in full again."
    },
    "message": {
      "save-security-codes": "Put these codes in a safe place.",
      "if-you-lose": "If you lose your device and don't have the recovery codes you will lose access to your account."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Generate two-factor authentication (2FA) recovery codes",
      "generate": "Generate Recovery Codes"
    },
    "validations": {},
    "message": {
      "alert-1": "Put these codes in a safe place.",
      "alert-2": " If you lose your device and don't have the recovery codes you will lose access to your account.",
      "alert-3": "Generating new recovery codes does not change the keys used in authenticator apps. If you wish to change the key used in an authenticator app you should",
      "alert-4": "reset your authenticator keys."
    }
  },
  "security-login": {
    "title": {
      "login": "Login"
    },
    "label": {
      "username": "Username",
      "password": "Password",
      "rememberMe": "Remember me",
      "loginButton": "Login",
      "passwordRecovery": "Recover password",
      "notRegistered": "Not registered yet ?",
      "signup": "Sign up now",
      "loginAlternative": "or",
      "forgotPassword": "Forgot your password?",
      "next": "Next",
      "forgotPasswordInstructions": "Enter your user name and we will send you a mail with detailed instructions to recover it",
      "externalLogin": "External Login",
      "captcha-placeholder": "Enter Captcha"
    },
    "validations": {
      "usernameRequired": "The field Username is required",
      "passwordRequired": "The field Password is required",
      "captchaValidationRequired": "Captcha validation is required"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Two-factor authentication",
      "login-recovery": "Recovery code verification"
    },
    "label": {
      "twoFactorCode": "Authenticator code",
      "recoveryCode": "Recovery code",
      "rememberBrowser": "Remember this browser",
      "verificationCodeInstructions": "Enter the six-digit code from your authenticator app to continue.",
      "loginButton": "Login",
      "loginRecovery": "Login with a recovery code"
    },
    "message": {
      "no-access": " Don't have access to your authenticator device? You can",
      "trustedBrowser": "Skip verification on this trusted browser.",
      "recovery-requested": " You have requested to log in with a recovery code. This login will not be remembered until you provide an authenticator app code at log in or disable 2FA and log in again."
    },
    "validations": {
      "twoFactorCode": "The field Authenticator code is required",
      "recoveryCode": "The field Recovery code is required"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Recover Password",
      "changePassword": "Change password",
      "userName": "User Name",
      "newPassword": "New password",
      "repeatPassword": "Repeat password",
      "returnLogin": "Return to Login"
    },
    "message": {
      "email-sended": "Recover password email sended",
      "password-changed": "Password changed successfully"
    },
    "validations": {
      "newPassword": "New password must be at least 6 characters",
      "passwordEqual": "Password does not match"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Setup authenticator app",
      "reset": "Reset authenticator key",
      "configure": "Configure authenticator app"
    },
    "validations": {},
    "message": {
      "alert-1": "If you reset your authenticator key your authenticator app will not work until you reconfigure it.",
      "alert-2": "This process disables 2FA until you verify your authenticator app.",
      "alert-3": "If you do not complete your authenticator app configuration you may lose access to your account.",
      "success": "Your authenticator app key has been reset, you will need to configure your authenticator app using the new key."
    }
  },
  "tfa": {
    "title": {
      "page": "Two Factor Authentication"
    },
    "label": {
      "title": "Two-factor authentication (2FA)",
      "authenticator-app": "Authenticator app",
      "setup-authenticator": "Setup authenticator app",
      "add-authenticator": "Add authenticator app",
      "reset-authenticator": "Reset authenticator app",
      "reset-recovery-codes": "Reset recovery codes",
      "disable-2fa": "Disable 2FA",
      "forget-this-browser": "Forget this browser",
      "status-enabled": "Enabled",
      "status-disabled": "Not configured",
      "recovery-codes-remaining": "recovery codes available",
      "danger-zone": "High-impact actions"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "The current browser has been forgotten. When you login again from this browser you will be prompted for your 2fa code.",
      "no-codes-left-1": "You have no recovery codes left.",
      "no-codes-left-2": "You must",
      "no-codes-left-3": "generate a new set of recovery codes",
      "no-codes-left-4": "before you can log in with a recovery code.",
      "some-codes-left-1": "You have",
      "some-codes-left-2": "recovery codes left.",
      "some-codes-left-3": "You should ",
      "some-codes-left-4": "generate a new set of recovery codes"
    }
  },
  "roles": {
    "account_reports": "Account Reports",
    "catalogs_admin": "Catalogs Administrator",
    "details_reports": "Details Reports",
    "environments_admin": "Environment Administrator",
    "forms_admin": "Forms Administrator",
    "management_report_admin": "Management Reports Administrator",
    "notifications_admin": "Notifications Administrator",
    "system_auditor": "System Auditor",
    "taxpayer_reports": "Taxpayer Reports",
    "taxpayers_admin": "Taxpayers Administrator",
    "payments_admin": "Payment Manager",
    "taxpayers_approver": "Taxpayers Approver",
    "taxreturn_approver": "$t(config.taxReturn) Approver",
    "taxreturn_reports": "$t(config.taxReturn) Reports",
    "tfa_admin": "2FA Administrator",
    "users_admin": "Users Administrator",
    "current_account_admin": "Current Account Manager",
    "debt_collection_analyst": "Debt collection analyst",
    "debt_collection_manager": "Debt collection manager",
    "debt_collection_officer": "Debt collection officer",
    "taxpayer_communication": "Communication to the taxpayer",
    "non_compliance_analyst": "Non compliance analyst",
    "collection_statistics": "Collection analysis",
    "compliance_statistics": "Non compliance analysis",
    "disbursement_view": "View disbursements",
    "disbursement_manage": "Manage disbursements"
  },
  "payments": {
    "declaration": "Payment Declaration",
    "transaction": "Payment Transaction",
    "bankUploadSuccess": "The bank information about payments was successfully stored",
    "bankUploadSuccessNotes": "The taxpayer's payments will be processed and made available for viewing in the system."
  },
  "taxes": {
    "editTax": "Edit tax",
    "createTax": "Add new tax",
    "title": {
      "page": "Manage Taxes"
    },
    "label": {
      "name": "Name",
      "rateType": "Rate Type",
      "shortName": "Short Name",
      "code": "Code",
      "newButton": "New",
      "saveButton": "Save",
      "tabEditTax": "General",
      "tabRates": "Rates",
      "rate": "Rate",
      "tabPeriodicity": "Periodicity",
      "tabOperations": "Operations",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "value": "Value",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day",
      "paymentDueDay": "Payment day"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "rateType": "Rate Type",
      "value": "Value",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "shortName": "Short Name",
      "actions": "Actions",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day"
    },
    "validations": {
      "rateTypeRequired": "The field Rate Type is required",
      "shortNameRequired": "The field Short Name is required",
      "codeRequired": "The field Code is required",
      "valueLessThan100": "The field Value should be less thant 100%",
      "valueRequired": "The field Value is required",
      "dateFromRequired": "The field Date From is required",
      "dateToRequired": "The field Date To is required",
      "filingDueDayRequired": "The field Filing Due Day is required",
      "periodicityTypeRequired": "The field Periodicity Type is required"
    },
    "messages": {
      "savedSuccessfully": "Saved successfully",
      "deletedSuccessfully": "Deleted successfully",
      "error": "Error"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Manage Report Operations",
      "warning": "Warning"
    },
    "label": {
      "operation": "Operation",
      "report": "Report"
    },
    "header": {
      "operation": "Operation",
      "report": "Report",
      "actions": "Actions"
    },
    "messages": {
      "removeReportOperation": "Are you sure delete it?"
    }
  },
  "reports": {
    "title": {
      "page": "Manage Reports",
      "report": "Report",
      "versions": "Versions"
    },
    "label": {
      "name": "Name",
      "shortName": "Short Name",
      "code": "Code",
      "newButton": "New",
      "saveButton": "Save",
      "tabEditReport": "General",
      "tabPeriodicity": "Periodicity",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "shortName": "Short Name",
      "actions": "Actions",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "periodicityType": "Periodicity Type",
      "filingDueDay": "Filing Due Day"
    },
    "validations": {
      "shortNameRequired": "The field Short Name is required",
      "codeRequired": "The field Code is required",
      "dateFromRequired": "The field Date From is required",
      "dateToRequired": "The field Date To is required",
      "filingDueDayRequired": "The field Filing Due Day is required",
      "periodicityTypeRequired": "The field Periodicity Type is required"
    },
    "messages": {
      "savedSuccessfully": "Saved successfully",
      "deletedSuccessfully": "Deleted successfully",
      "error": "Error"
    }
  },
  "report-cells": {
    "title": {
      "page": "Cells"
    },
    "label": {
      "code": "Cell code",
      "name": "Cell name",
      "description": "Description",
      "formula": "Formula",
      "order": "Order",
      "type": "Type",
      "numeric": "Numeric",
      "currency": "Currency",
      "date": "Date",
      "list": "List",
      "text": "Text",
      "catalogType": "Catalog Type",
      "mandatory": "Mandatory"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure do you want to delete it?"
    }
  },
  "report-version": {
    "title": {
      "page": "Report version"
    },
    "label": {
      "version": "Version",
      "formVersion": "Form version",
      "startDate": "Start date",
      "endDate": "End date",
      "formCode": "Form code",
      "formName": "Form name",
      "since": "Since",
      "tabVersion": "Version",
      "fields": "Fields"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure deleted?"
    }
  },
  "taxOperation": {
    "title": {
      "page": "Manage Tax Operations",
      "warning": "Warning"
    },
    "label": {
      "operation": "Operation",
      "tax": "Tax"
    },
    "header": {
      "operation": "Operation",
      "tax": "Tax",
      "actions": "Actions"
    },
    "messages": {
      "removeTaxOperation": "Are you sure delete it?",
      "allOperationsLinked": "All operations are already linked to this tax",
      "noLinkedOperations": "There are no operations linked to this tax"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Current Account",
      "currentAccountJurisdiction": "Current Account",
      "amendingCredit": "Balance inquiry",
      "currentAccountTransaction": "Transactions detail",
      "currentAccountJurisdictionTransaction": "Transactions detail",
      "transactionAdjustment": "Balance adjustment"
    },
    "subtitle": {
      "currentAccountJurisdiction": "Information by Jurisdiction",
      "currentAccountJurisdictionTransaction": "Information for a particular Jurisdiction"
    },
    "label": {
      "nit": "TIN",
      "tax": "Tax",
      "taxCode": "Tax code",
      "period": "Period",
      "taxAmount": "Tax amount",
      "penalty": "Penalty",
      "interest": "Interest",
      "taxArrears": "Tax arrears",
      "total": "total",
      "expirationDate": "Expiration date",
      "accountType": "Account type",
      "balance": "Balance",
      "date": "Date",
      "transactionType": "Transaction type",
      "value": "Value",
      "document": "Document",
      "taxpayerName": "Name",
      "credit": "Credit",
      "debit": "Debit"
    },
    "dialog": {},
    "messages": {},
    "validations": {
      "nit-required": "Nit required"
    }
  },
  "taxpayer-payments": {
    "title": {
      "page": "View payments",
      "paymentsByJurisdiction": "Payments by Jurisdiction",
      "pagePayments": "Record payment",
      "pageUploadPayments": "Upload bank information",
      "selectTaxReturn": "Select $t(config.taxReturn)",
      "reconciliationPayments": "Reconciliation of payments",
      "paymentsTaxpayer": "Payments reported by the taxpayer.",
      "paymentsTaxCollect": "Payments reported by the collecting entity.",
      "concialiation": "Conciliation.",
      "checkBankInformation": "View bank information"
    },
    "label": {
      "registerPayment": "Record payment",
      "amountTaxReturn": "Declaration amount",
      "totalDebt": "Total debt",
      "amountTaxpayer": "Taxpayer amount.",
      "amountBank": "Bank amount",
      "amountFrom": "Amount from",
      "amountTo": "Amount up to",
      "tax-id": "Tax identification",
      "name": "Name",
      "date-from": "Date from",
      "date-to": "Date to",
      "date-payment": "Payment date",
      "payment-number": "Payment number",
      "exchange-rate": "Exchange rate.",
      "local-amount": "Amount in local currency",
      "tax": "Tax",
      "amount": "Amount",
      "excelDefinition": "Excel file definition",
      "taxCollector": "Tax collector",
      "swiftNumber": "Swift confirmation number",
      "uploadNumber": "Upload number",
      "hasErrors": "Has errors",
      "date-payment-bank": "Date received"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Payment successfully registered on [createDate]",
      "diferentCurrencyCode": "You cannot reconcile payments of different currencies",
      "exceedsTolerance": "Exceeds the [tolerence]% tolerance allowed",
      "paymentGreaterThen": "Payments reported by the taxpayer are higher than the payment reported by the tax collector",
      "paymentInformationWarning": "If the information concerning the Swift code is not provided, the payment cannot be correctly identified and the declaration will be considered unpaid"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Taxpayers list"
    },
    "label": {
      "name": "Name",
      "nit": "TIN",
      "county": "Country",
      "personType": "Person type",
      "email": "Email"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Person",
      "businessName": "Business name",
      "fullName": "Full name",
      "id": "Identity card number",
      "taxNumber": "Tax Identification Number in the country of residence",
      "phoneNumber": "Phone number",
      "domicile": "Domicile",
      "department": "Department/Provice/State",
      "addContact": "Add contact",
      "operations": "Operations",
      "contacts": "Contacts",
      "taxVector": "Tax vector",
      "reportVector": "Report",
      "generalData": "General",
      "tax": "Tax",
      "taxObligation": "Tax",
      "report": "Report",
      "website": "Web site",
      "idTax": "Tax Identification Number in the country of residence",
      "contactName-tax": "Main Contact Name",
      "docNumberContact-tax": "Contact Identity card number",
      "contactTaxIdNumber-tax": "Tax of the contact in the country of residence",
      "phoneNumberContact-tax": "Contact phone number in country of residence",
      "email-tax": "Contact E-Mail",
      "documents": "Documents",
      "docCompanyRegistrationNumber": "Company registration document",
      "docLocalContact": "Local contact registered identity",
      "acceptance": "Acceptance",
      "taxpayerRequest": "POSS registration",
      "confirmTerms": "Accept the terms and conditions",
      "terms": "Lorem ipsum dolor sit amet consectetur adipiscing elit per, penatibus euismod ac libero praesent sollicitudin lacinia nulla platea, nam hac cursus cubilia congue luctus dapibus. Iaculis luctus egestas accumsan eleifend metus dis aptent quisque, lacus vitae nullam habitasse ad mollis tempor, mattis ornare dapibus laoreet auctor tellus dui. Ante integer sagittis erat accumsan vulputate potenti senectus, rutrum ullamcorper nam hendrerit ridiculus faucibus, parturient fames ligula venenatis tristique inceptos.\n\nCum aliquet tempor cras non potenti inceptos aptent, mauris scelerisque mollis auctor libero porta id ut, sodales vulputate eget imperdiet netus posuere. Iaculis dignissim himenaeos magna luctus nulla egestas porttitor, eros vulputate volutpat sociosqu quisque mollis donec, class placerat justo vivamus imperdiet accumsan. Ultrices facilisi phasellus augue cursus etiam viverra suspendisse est, nam vulputate tempor posuere dignissim feugiat sed hac sodales, diam tristique pretium auctor ad erat sem. Et enim gravida magnis malesuada nam nascetur fermentum, proin platea elementum nec penatibus ultricies, blandit cubilia aptent neque praesent sociis.\n\nSagittis augue enim nam sociis, ornare est mi himenaeos, risus proin sodales. Proin malesuada integer aliquam cubilia neque natoque velit, feugiat elementum quis quisque suscipit fermentum conubia, nisi a ligula duis sapien tellus. Praesent mattis fringilla habitant nulla sollicitudin bibendum habitasse at cum quis mus iaculis mi magna sodales, velit hendrerit inceptos dictum neque montes turpis tellus nam morbi commodo nullam senectus.\n\nArcu primis eu conubia fusce nisi vehicula posuere leo sollicitudin eleifend, phasellus sodales congue ligula consequat volutpat magnis facilisi curabitur maecenas, et dis velit libero hac proin habitant sociis nascetur. Nunc tortor penatibus mi ultrices risus nec elementum justo, mattis ad ac tempus vel habitasse accumsan sed parturient, lectus lacinia conubia malesuada volutpat egestas nulla. Himenaeos consequat vitae class mattis taciti nec habitant eleifend, elementum netus eget parturient suspendisse porttitor in felis maecenas, curabitur morbi odio gravida vivamus per bibendum.\n\nTortor non sociosqu accumsan orci vel ligula risus nisl, penatibus odio magnis ullamcorper pellentesque habitant lacinia consequat, aptent nec congue nisi egestas sociis quam. Turpis sociis eu est parturient in fames aliquet nisl, dui natoque phasellus aliquam posuere curae aptent porta, tortor condimentum molestie netus cubilia inceptos lacinia. Auctor laoreet purus nostra dapibus sollicitudin tincidunt dictum nisl lacinia erat, est rhoncus fusce phasellus blandit etiam inceptos suspendisse magna, duis pellentesque nam hac neque mus dignissim a enim.\n\nNeque proin felis laoreet senectus nullam netus sollicitudin odio tincidunt, penatibus parturient facilisis porta duis sagittis malesuada varius sociosqu congue, aptent velit pellentesque mauris egestas nibh semper orci. Dis sociosqu at torquent nec commodo erat eu pharetra natoque, senectus velit nascetur curae sollicitudin mus phasellus. Aenean diam ut nibh vulputate neque fusce penatibus class porta mattis imperdiet risus ante, ac lectus habitasse posuere facilisis luctus varius mus tempus non mollis.\n\nDictumst eleifend vehicula purus hendrerit volutpat primis integer, per senectus fusce nulla cubilia dictum feugiat auctor, ultricies sociosqu nisl mi class magnis. Ligula himenaeos phasellus pulvinar accumsan platea egestas sodales hendrerit sagittis augue, curae nec molestie pretium cum parturient lacus euismod sociosqu ullamcorper duis, dignissim fusce libero maecenas congue lobortis penatibus nisi justo.\n\nCum rutrum vehicula convallis pellentesque maecenas nascetur proin congue platea, posuere neque facilisi ullamcorper nibh curae sodales non, cursus nisl cras morbi interdum vitae auctor cubilia. Ligula taciti enim donec congue bibendum fusce eros rhoncus suscipit, dui parturient potenti odio sapien non erat eget, tincidunt convallis primis quam tortor consequat sodales per. Neque hendrerit erat nunc hac ullamcorper molestie fermentum, tristique ultrices sociis vivamus volutpat lectus, vestibulum vehicula aenean mattis magna posuere. Justo condimentum tempor taciti laoreet inceptos per hendrerit eleifend consequat lacus nostra enim, convallis praesent dui faucibus lobortis quam pharetra odio mauris duis.\n\nMagna ultrices dui netus laoreet odio rhoncus maecenas nec placerat rutrum, massa duis nam nulla velit quis fringilla habitasse. Eu integer diam lectus ullamcorper torquent ante aliquet cras feugiat inceptos placerat ut, porta libero nam mauris volutpat habitasse iaculis lacinia facilisi hendrerit nostra.\n\nLaoreet risus nisi sociosqu inceptos maecenas blandit phasellus bibendum, nostra velit fringilla tristique mus donec lectus semper, est tortor nascetur curae scelerisque himenaeos sagittis. Quam volutpat eros non nec nascetur justo, velit tristique nisl arcu est, ultricies sapien convallis metus vulputate. Condimentum justo ad varius habitant nunc gravida sed vivamus, maecenas ut congue aenean ligula proin lectus, natoque urna duis dui semper egestas habitasse.\n\nAnte et luctus porta malesuada accumsan cursus senectus dictumst penatibus pretium nullam, id condimentum proin felis aliquam sollicitudin varius velit lobortis class placerat, praesent ridiculus eget nisl metus tristique maecenas semper himenaeos parturient. Enim laoreet vulputate orci dui lectus purus bibendum vivamus posuere est curabitur, cubilia fames nulla porta in scelerisque cursus nunc a ligula pretium dictum, mi molestie pulvinar torquent litora vitae fusce eget curae sem. Dapibus quam facilisi cras pharetra mus curabitur, parturient a malesuada integer vitae etiam suspendisse, fermentum massa libero curae neque.",
      "locale": "Preferred Language",
      "queryOfRequest": "Query of Request",
      "acquirerId": "Acquirer ID",
      "acquirerCountry": "Acquirer country",
      "terminalId": "Terminal ID",
      "merchantCategoryCode": "Merchant category code",
      "merchantId": "Merchant ID",
      "documentNumberCountryResidence": "Document number in the country of residence"
    },
    "vector": {
      "label": {
        "tax": "Tax",
        "expiration": "Filing Due Day",
        "periodicity": "Periodicity",
        "startOperation": "Registration Start Date"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "At least one contact is required",
      "operations": "At least one operation is required",
      "selectOperations": "Associated operations",
      "withoutOperations": "No operations",
      "withoutOperationsVector": "It has no associated taxes",
      "withoutOperationsReport": "It has no associated reports",
      "withoutDocuments": "There is no file definition"
    },
    "validations": {
      "acceptance": "Field must be checked",
      "formComplete": "Complete the entire form"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Taxpayer Requests",
      "approve": "Approve Request",
      "reject": "Reject Request",
      "request-additional-info": "Request Additional Information",
      "request": "Request"
    },
    "label": {
      "check-digit": "Check digit",
      "date-from": "Date From",
      "date-to": "Date To",
      "request-type": "Request Type",
      "request": "Request",
      "type": "Type",
      "taxpayer": "Taxpayer",
      "state": "State",
      "approve": "Approve",
      "reject": "Reject",
      "request-additional-info": "Return",
      "comments": "Comments",
      "reason": "Reason",
      "createdDate": "Date",
      "cancellationDate": "Cancellation date"
    },
    "message": {
      "approved": "Request Approved",
      "rejected": "Request Rejected",
      "request-additional-info": "Additional Information Requested",
      "periodictyOutOfDate": "A tax or reporting periodicity is out of date"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "View $t(config.taxReturns)"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "$t(config.taxReturn) Number",
      "country": "Country",
      "formId": "Form",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "name": "Taxpayer Name",
      "period": "Period",
      "periodFrom": "Period From",
      "periodTo": "Period To",
      "active": "Active"
    },
    "header": {
      "actions": "Actions",
      "nit": "TIN",
      "name": "Taxpayer Name",
      "taxReturnNumber": "$t(config.taxReturn) Number",
      "createDate": "Creation Date",
      "taxreturnType": "Operation Type",
      "taxreturnStatus": "Status",
      "form": "Form",
      "period": "Period",
      "active": "Active"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Update registration"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Unsuscribe"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "Send message"
    },
    "label": {
      "nit": "TIN",
      "taxpayerName": "Name",
      "subject": "Subject",
      "message": "Message"
    }
  },
  "form-administration": {
    "title": {
      "page": "Tax Statement Form Administration ",
      "form": "Form",
      "versions": "Versions"
    },
    "label": {
      "code": "Code",
      "name": "Name",
      "shortName": "Short name",
      "tax": "Tax",
      "numberModifications": "Number Modifications",
      "amendmentApprovalRequired": "Amendment Approval Required",
      "form": "Forms",
      "versions": "Versions"
    },
    "header": {
      "actions": "Actions",
      "code": "Code",
      "name": "Name",
      "shortName": "Short name",
      "tax": "Tax"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure deleted?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Cells",
      "serviceParameters": "Service Parameters",
      "serviceHeaders": "Service Header"
    },
    "label": {
      "noFoundCells": "The form has no defined cells",
      "code": "Cell code",
      "name": "Cell name",
      "description": "Description",
      "section": "Section",
      "formula": "Formula",
      "order": "Order",
      "type": "Type",
      "service": "Service",
      "mandatory": "Mandatory",
      "editable": "Editable",
      "visible": "Visible",
      "cellPurpose": "Cell purpose",
      "numeric": "Numeric",
      "currency": "Currency",
      "date": "Date",
      "list": "List",
      "text": "Text",
      "catalogType": "Catalog Type",
      "parameterName": "Name",
      "addParameter": "Add Parameter",
      "headerName": "Name",
      "addHeader": "Add Header"
    },
    "messages": {
      "confirmTitle": "Delete",
      "confirmDeleted": "Are you sure deleted?"
    }
  },
  "form-section": {
    "labels": {
      "description": "Description",
      "order": "Order",
      "code": "Code",
      "sectionType": "Section type",
      "isMultiple": "Multiple",
      "minInstances": "Minimum instances",
      "maxInstances": "Maximum instances"
    },
    "provisioning": {
      "simple": "Simple",
      "multiple": "Multiple",
      "jurisdiction": "Jurisdiction"
    }
  },
  "form-version": {
    "title": {
      "page": "Tax Statement Form version",
      "current-account-rules": "Current Account Rules"
    },
    "labels": {
      "noFoundVersion": "There is no version configured",
      "version": "Version",
      "formVersion": "Form version",
      "startDate": "Start date",
      "endDate": "End date",
      "formCode": "Form code",
      "formName": "Form name",
      "since": "Since",
      "generalData": "General data",
      "fields": "Cells",
      "sections": "Sections",
      "enabled": "Enabled",
      "preview": "Preview",
      "current-account-rules": "Current Account Rules",
      "account-type-header": "Account type",
      "transaction-type-header": "Transaction type",
      "cell-header": "Cell",
      "account-type": "Account type",
      "transaction-type": "Transaction type",
      "cell": "Cell"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Preview",
      "year": "Period",
      "taxpayer": "Taxpayer Id",
      "nit": "TIN",
      "taxpayerName": "Taxpayer Name",
      "validTestTaxpayer": "Not found a Taxpayer valid to test",
      "validTestTax": "Taxpayer does not have a tax related to this form",
      "formulaLog": "Formula log"
    },
    "messages": {
      "formVersionNotFound": "Form version not found",
      "taxReturnExist": "Taxreturn already exists for this period"
    }
  },
  "appMenu": {
    "audit-log-application-http": "Application http log",
    "audit-log-security-http": "Security http log",
    "catalog": "Catalogs",
    "collection_compliance": "Collection and Compliance",
    "collection_statistics": "Collection Statistics",
    "compliance_statistics": "Compliance Statistics",
    "configuration": "Settings",
    "configure_penalties": "Penalties configuration",
    "debt_collection_manage": "View processes",
    "disable-tfa-to-user": "Disable Two Factor Authentication (2FA)",
    "economy-activity": "Operations",
    "environment-application": "Application variables",
    "environment-security": "Security variables",
    "home-template": "Home Template",
    "manage-form": "Forms",
    "manage-report-operations": "Supplementary Reports Operations",
    "manage-report": "Supplementary Reports",
    "manage-tax-operations": "Taxes Operations",
    "manage-tax": "Taxes",
    "management-report-payment": "Payments",
    "management-report-taxpayer": "Taxpayers",
    "management-report-taxreturn": "$t(config.taxReturn)",
    "management-report": "Management Reports",
    "non_compliance": "Non-Compliance control",
    "notifications-application": "Application Notifications",
    "notifications-security": "Security Notifications",
    "operations": "Operations",
    "query-payments-taxofficer": "View Payments",
    "report-details": "View Supplementary Reports",
    "reports": "$t(config.taxReturns)",
    "security": "Security",
    "send-message-taxpayer": "Send message",
    "statements-tax-officer": "$t(config.taxReturn)",
    "currentAccount": "Current Account",
    "currentAccountJurisdiction": "Current Account (Jurisdictions)",
    "taxes": "Taxes",
    "taxofficer-check-load-payments": "View bank information",
    "taxofficer-payment-record": "Record payment",
    "taxofficer-reconciliation-payments": "Reconcile payments",
    "taxofficer-taxreturn-payments": "Payments",
    "taxofficer-transaction-adjustment": "Balance adjustment",
    "taxofficer-upload-payments": "Upload bank information",
    "taxpayer-feedback": "Feedback",
    "taxpayer-fields": "Taxpayer Fields",
    "taxpayer-report": "View Taxpayers",
    "taxpayer-requests": "Taxpayer Requests",
    "taxpayers": "Taxpayers",
    "taxreport-report": "View $t(config.taxReturns)",
    "taxreturn-evaluation": "Review Amendments",
    "terms-template": "Terms and conditions Template",
    "two-factor-authentication": "Two Factor Authentication",
    "user-taxpayers": "Taxpayers",
    "users": "Users",
    "disbursement": "Disbursement",
    "disbursementView": "View disbursements",
    "disbursementManage": "Manage disbursement"
  },
  "disbursement": {
    "title": "Disbursement",
    "noPending": "No pending disbursements",
    "viewDisbursements": "View disbursements",
    "disbursementComments": "Comments",
    "disbursementDate": "Date",
    "disbursementCreate": "Create disbursement",
    "register": "Register disbursement",
    "registerNote": "According to the Pending disbursements amounts",
    "recordSuccess": "The disbursement was successfully stored",
    "recordSuccessNotes": ""
  }
}
